<template>
    <div id="loyaltyComponent">
        <div class="voucherComponent-inner" v-bind:class="{loading:loading}">
            <div class="wz-row">
                <template v-if="user_id">
                    <h3 class="title">voucher của bạn</h3>
                    <h4 class="desc" v-if="vouchers.length">Bạn có {{vouchers.length}} voucher hiện tại</h4>
                    <h4 class="desc" v-else>Hiện tại bạn không có voucher nào</h4>
                    <div class="voucherList">
                        <div class="item" v-for="voucher in vouchers">
                            <div class="info">
                              <div class="inner" v-if="voucher.discount_extra">
                                <p>
                                  Mã
                                  <span class="code">{{voucher.voucher_code}}</span>
                                  <span class="price">{{voucher.discount_extra * 100}}%</span>
                                  Với voucher
                                </p>

                              </div>
                              <div class="inner" v-else>
                                <p>
                                  Tặng
                                  <span class="price">{{voucher.discount_amount | formatPrice2}}<span>đ</span></span>
                                </p>
                              </div>
                              <img src="../assets/images/voucher.png" alt="">
                            </div>
                          <p class="desc">{{voucher.voucher_description}}</p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Voucher',
        data() {
            return {
                vouchers: [],
                user_id: this.$foodbookConfig.user_phone,
                loading: true
            };
        },
        created() {
            if (parseInt(this.user_id)) {
                this.getVoucher(this.user_id);
            } else {
                this.$toasted.show("The system has not been processed yet. Please try again later..", {
                    position: "top-center",
                    duration: 10000,
                    type: 'error'
                });
            }
        },
        filters: {
            filterVouchersActive: function (vouchers) {
                return vouchers.filter(voucher => {
                    //4: OK, 3: hết hạn, 2: đã sử dụng, 1: ko tồn tại
                    return (voucher.status === 4)
                })
            }
        },
        methods: {
            getVoucher($phone) {
                this.loading = true;
                this.$http.get(this.$foodbookConfig.wpapi + '/member_vouchers', {
                    params: {
                        user_id: $phone
                    }
                }).then(response => {
                    if (!response.body.data) {
                        this.$toasted.show("The system has not been processed yet. Please try again later..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        this.loading = false;
                    } else {
                        this.vouchers = this.$options.filters.filterVouchersActive(response.body.data);
                        this.loading = false;
                        // console.log(this.vouchers);
                    }
                }, response => {
                    // error callback
                    console.log("Error getVoucher");
                    this.loading = false;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/voucher.vue